/* Renk Sahnesi — yeni bölümlerin etkileşimleri. Saf JS, bağımlılık yok.
   Sepet işlemleri oyunperest.js'tedir (data-op-add, data-op-product-form).
   DİKKAT: bu temada kaydırma window'da değil .page-wrapper içindedir; kaydırma
   dinleyicileri bu yüzden document'e capture ile bağlanır. */
(function () {
  'use strict';

  /* Hareket azaltma tercihi: programla yapılan kaydırmalar da yumuşak değil anında olur */
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var glide = calm ? 'auto' : 'smooth';

  function onScroll(fn) {
    var queued = false;
    var tick = function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; fn(); });
    };
    document.addEventListener('scroll', tick, { capture: true, passive: true });
    window.addEventListener('resize', tick);
    /* Kapak görseli ve yazı tipi sonradan yerleşince düzen kayar (başlık satır sayısı değişir):
       kaydırma olmadan da yeniden ölçülür, yoksa sabit satın alma çubuğu ilk ekranda eksik kalabilir */
    window.addEventListener('load', tick);
    if (document.fonts && document.fonts.ready && document.fonts.ready.then) document.fonts.ready.then(tick, tick);
    fn();
  }

  /* ---- Sabit satın alma çubuğu: asıl düğme ekranda değilken görünür ---- */
  var anchor = document.querySelector('[data-rs-buy-anchor]');
  var bar = document.querySelector('[data-rs-sticky]');
  if (anchor && bar) {
    /* Sayfanın en sonunda çubuk çekilir; yoksa alt bilginin son satırlarını örter.
       Ölçü, alt bilgi grubunu saran <footer>'dır; bulunamazsa bölümün kendisi (.rs-footer). */
    var foot = document.querySelector('.page-wrapper > footer') || document.querySelector('.rs-footer');
    var first = true;
    onScroll(function () {
      var r = anchor.getBoundingClientRect();
      /* Çubuk yalnız asıl düğme kaydırılıp YUKARIDA kaldığında çıkar. Eskiden düğme ekranın altında
         kaldığında da çıkıyordu: uzun adlı kitapta sayfa açılırken çubuk geliyor, düğmeye inerken
         kayboluyor, geçince yeniden geliyordu (300px içinde üç kez). */
      var away = r.bottom < 40;
      /* Pay geniş tutulur: telefonda adres çubuğu açılıp kapanırken çubuk titremesin */
      var atEnd = !!foot && foot.getBoundingClientRect().bottom <= window.innerHeight + 24;
      /* İlk ölçüm (sayfa ortasından yeniden yüklenince) kayma animasyonu olmadan yerleşir */
      if (first) {
        first = false;
        bar.classList.add('is-instant');
        requestAnimationFrame(function () { requestAnimationFrame(function () { bar.classList.remove('is-instant'); }); });
      }
      bar.classList.toggle('is-on', away && !atEnd);
    });

    /* Çift gönderim kilidi ve sabit çubuk düğmesinin bekleme halkası oyunperest.js'tedir
       (event.submitter): ikinci bir kilit 15 sn sonraki yeniden denemeyi kalıcı engelliyordu. */
  }

  /* ---- Yatay galerilerde "2 / 7" sayacı ---- */
  document.querySelectorAll('[data-rs-scroller]').forEach(function (sc) {
    var section = sc.closest('section') || sc.parentNode;
    var out = section.querySelector('[data-rs-count]');
    if (!out || !sc.children.length) return;
    var total = sc.children.length;
    /* Hepsi ekrana sığıyorsa (geniş ekranda birkaç kapak) sayaç anlamsızdır */
    /* Kaydırılacak bir şey yoksa şerit sekme durağı da olmaz (işlevsiz, ekran genişliğinde odak halkası) */
    var fits = function () {
      var all = sc.scrollWidth <= sc.clientWidth + 8;
      out.hidden = all;
      if (!sc.querySelector('button, a[href]')) sc.tabIndex = all ? -1 : 0;
    };
    fits();
    window.addEventListener('resize', fits);
    window.addEventListener('load', fits);
    var queued = false;
    sc.addEventListener('scroll', function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        /* Adım, iki öğe arasındaki gerçek mesafedir (boşluk dar ve geniş ekranda farklı) */
        var step = total > 1
          ? sc.children[1].offsetLeft - sc.children[0].offsetLeft
          : sc.children[0].getBoundingClientRect().width;
        if (!(step > 0)) return;
        /* Geniş ekranda birkaç sayfa birden görünür: şerit sona dayandıysa son sayfa da görülmüştür */
        var atEnd = sc.scrollLeft + sc.clientWidth >= sc.scrollWidth - 8;
        out.textContent = (atEnd ? total : Math.min(total, Math.round(sc.scrollLeft / step) + 1)) + ' / ' + total;
      });
    }, { passive: true });
  });

  /* ---- İçine bak: açılıma dokununca tam ekran görüntüleyici ----
     Telefonda çift sayfa açılım ekran genişliğine iner ve metni okunmaz; burada aynı görsel
     büyük kaynağından ekranı dolduracak kadar açılır. Görselde bir dokunuş yakın görünüme geçer
     (parmakla/fareyle gezilir), ikinci dokunuş geri döner. Sayfalar arasında kaydırma, ok
     düğmeleri ve klavye okları; Esc ya da Kapat ile çıkılır, odak açan düğmeye döner. Arkadaki
     sayfa kaymasın diye .page-wrapper (masaüstündeki kaydırıcı) kilitlenir. */
  var zoomStrip = document.querySelector('[data-rs-zoom]');
  if (zoomStrip && typeof HTMLDialogElement === 'function') {
    var zFigs = Array.prototype.slice.call(zoomStrip.querySelectorAll('figure[data-rs-full]'));
    var zLabel = zoomStrip.getAttribute('data-rs-zoom-label') || 'Sayfayı büyüt';
    var zCloseLabel = zoomStrip.getAttribute('data-rs-close-label') || 'Kapat';
    var zTitle = document.getElementById(zoomStrip.getAttribute('aria-labelledby') || '');
    var zIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.5 15.5 21 21M10.5 7.5v6M7.5 10.5h6"/></svg>';
    var zDlg = null;
    var zTrack = null;
    var zCount = null;
    var zPrev = null;
    var zNext = null;
    var zOpener = null;
    var zCur = 0;
    var touchOnly = window.matchMedia('(hover: none)').matches;

    var zUnzoom = function (slide) {
      if (!slide || !slide.classList.contains('is-zoomed')) return;
      slide.classList.remove('is-zoomed');
      var img = slide.querySelector('img');
      img.style.width = '';
      img.style.height = '';
      slide.scrollLeft = 0;
      slide.scrollTop = 0;
    };
    var zZoom = function (slide, img, x, y) {
      var r = img.getBoundingClientRect();
      if (!r.width) return;
      var ar = img.naturalWidth && img.naturalHeight ? img.naturalWidth / img.naturalHeight : r.width / r.height;
      /* En az iki buçuk kat, en az ekran yüksekliği: telefonda çift sayfa yatayda gezilir */
      var w = Math.max(r.width * 2.5, slide.clientHeight * ar);
      var fx = (x - r.left) / r.width;
      var fy = (y - r.top) / r.height;
      slide.classList.add('is-zoomed');
      img.style.width = Math.round(w) + 'px';
      img.style.height = Math.round(w / ar) + 'px';
      slide.scrollLeft = fx * w - slide.clientWidth / 2;
      slide.scrollTop = fy * (w / ar) - slide.clientHeight / 2;
    };
    var zSync = function () {
      var n = zFigs.length;
      zCount.textContent = (zCur + 1) + ' / ' + n;
      zPrev.disabled = zCur <= 0;
      zNext.disabled = zCur >= n - 1;
    };
    var zGo = function (index, instant) {
      var n = Math.max(0, Math.min(zFigs.length - 1, index));
      Array.prototype.forEach.call(zTrack.children, zUnzoom);
      zTrack.scrollTo({ left: n * zTrack.clientWidth, behavior: instant ? 'auto' : glide });
      zCur = n;
      zSync();
    };
    var zBuild = function () {
      zDlg = document.createElement('dialog');
      zDlg.className = 'rs rs-zoom';
      zDlg.setAttribute('aria-label', zTitle ? zTitle.textContent.trim() : zLabel);
      zDlg.innerHTML =
        '<div class="rs-zoom__track"></div>' +
        '<div class="rs-zoom__bar"><span class="rs-zoom__count" aria-live="polite"></span>' +
        '<button type="button" class="rs-zoom__btn" data-rs-zoom-close>✕</button></div>' +
        '<button type="button" class="rs-zoom__btn rs-zoom__nav rs-zoom__nav--prev" aria-label="Önceki sayfa">←</button>' +
        '<button type="button" class="rs-zoom__btn rs-zoom__nav rs-zoom__nav--next" aria-label="Sonraki sayfa">→</button>' +
        '<p class="rs-zoom__hint" aria-hidden="true">' + (touchOnly ? 'Yakından görmek için dokunun' : 'Yakından görmek için tıklayın') + '</p>';
      zTrack = zDlg.querySelector('.rs-zoom__track');
      zCount = zDlg.querySelector('.rs-zoom__count');
      zPrev = zDlg.querySelector('.rs-zoom__nav--prev');
      zNext = zDlg.querySelector('.rs-zoom__nav--next');
      var closeBtn = zDlg.querySelector('[data-rs-zoom-close]');
      closeBtn.setAttribute('aria-label', zCloseLabel);
      zFigs.forEach(function (fig) {
        var source = fig.querySelector('img');
        var slide = document.createElement('div');
        slide.className = 'rs-zoom__slide';
        var img = document.createElement('img');
        img.alt = source ? source.alt : '';
        img.decoding = 'async';
        img.loading = 'lazy';
        img.src = fig.getAttribute('data-rs-full');
        slide.appendChild(img);
        zTrack.appendChild(slide);
      });
      closeBtn.addEventListener('click', function () { zDlg.close(); });
      zPrev.addEventListener('click', function () { zGo(zCur - 1); });
      zNext.addEventListener('click', function () { zGo(zCur + 1); });
      zTrack.addEventListener('click', function (event) {
        var slide = event.target instanceof Element ? event.target.closest('.rs-zoom__slide') : null;
        if (!slide) return;
        var img = slide.querySelector('img');
        if (event.target === img) {
          if (slide.classList.contains('is-zoomed')) zUnzoom(slide);
          else zZoom(slide, img, event.clientX, event.clientY);
        } else if (!slide.classList.contains('is-zoomed')) {
          zDlg.close(); /* görselin dışındaki koyu alana dokunmak kapatır */
        }
      });
      var queued = false;
      zTrack.addEventListener('scroll', function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () {
          queued = false;
          var n = Math.round(zTrack.scrollLeft / (zTrack.clientWidth || 1));
          if (n !== zCur) {
            Array.prototype.forEach.call(zTrack.children, function (slide, i) { if (i !== n) zUnzoom(slide); });
            zCur = n;
            zSync();
          }
        });
      }, { passive: true });
      zDlg.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowRight') { event.preventDefault(); zGo(zCur + 1); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); zGo(zCur - 1); }
      });
      zDlg.addEventListener('close', function () {
        Array.prototype.forEach.call(zTrack.children, zUnzoom);
        document.documentElement.classList.remove('rs-zoom-open');
        /* görüntüleyicide gelinen sayfa şeritte de görünür kalır */
        var fig = zFigs[zCur];
        if (fig) zoomStrip.scrollLeft = fig.offsetLeft - zoomStrip.offsetLeft - (parseFloat(getComputedStyle(zoomStrip).paddingLeft) || 0);
        var back = fig ? fig.querySelector('.rs-acilim__buyut') : zOpener;
        if (back) back.focus({ preventScroll: true });
      });
      document.body.appendChild(zDlg);
    };
    var zOpen = function (index, opener) {
      if (!zDlg) zBuild();
      zOpener = opener;
      document.documentElement.classList.add('rs-zoom-open');
      zDlg.showModal();
      zGo(index, true);
      var current = zTrack.children[index] && zTrack.children[index].querySelector('img');
      if (current) current.loading = 'eager';
      zDlg.querySelector('[data-rs-zoom-close]').focus();
    };

    zFigs.forEach(function (fig, index) {
      var source = fig.querySelector('img');
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'rs-acilim__buyut';
      button.setAttribute('aria-label', zLabel + (source && source.alt ? ': ' + source.alt : ''));
      button.innerHTML = '<span aria-hidden="true">' + zIcon + zLabel + '</span>';
      button.addEventListener('click', function () { zOpen(index, button); });
      fig.appendChild(button);
    });
    /* Düğmeler sekme sırasını taşır (odaklanınca şerit kendiliğinden kayar); şerit ayrıca durak olmaz */
    if (zFigs.length) zoomStrip.tabIndex = -1;
  }

  /* ---- Video: dokununca oynat/durdur; aynı anda tek video ---- */
  /* Oynat düğmesi gerçek bir <button> ise (klavye ve ekran okuyucu için) etiketi duruma göre değişir */
  var setPlaying = function (wrap, playing) {
    wrap.classList.toggle('is-playing', playing);
    var button = wrap.querySelector('button[data-rs-play-label]');
    if (button) button.setAttribute('aria-label', button.getAttribute(playing ? 'data-rs-pause-label' : 'data-rs-play-label'));
  };
  document.addEventListener('click', function (event) {
    var wrap = event.target instanceof Element ? event.target.closest('[data-rs-video]') : null;
    if (!wrap || event.target.closest('a')) return; /* karttaki bağlantı videoyu oynatmaz, kitaba götürür */
    var video = wrap.querySelector('video');
    if (!video) return;
    document.querySelectorAll('[data-rs-video] video').forEach(function (other) {
      if (other !== video) { other.pause(); setPlaying(other.closest('[data-rs-video]'), false); }
    });
    if (video.paused) {
      var started = video.play();
      if (started && started.catch) started.catch(function () { setPlaying(wrap, false); });
      setPlaying(wrap, true);
    } else {
      video.pause();
      setPlaying(wrap, false);
    }
  });
  document.addEventListener('ended', function (event) {
    var wrap = event.target instanceof Element ? event.target.closest('[data-rs-video]') : null;
    if (wrap) setPlaying(wrap, false);
  }, true);

  /* ---- Açıklama düzeni (ürün sayfası) ----
     Mağaza açıklamaları eski siteden geldiği için başlarında gömülü videolar,
     sonlarında düz bir bağlantı dizisi (Instagram, mağaza, YouTube, uygulama) var.
     İçerik silinmez, yalnız yeri değişir: videolar metnin altında bir ızgaraya,
     sondaki bağlantılar küçük çiplere taşınır. JS yoksa hepsi yerinde kalır. */
  var blankText = function (node) {
    return !/\S/.test(node.nodeValue.replace(/\u00a0/g, ' '));
  };
  var trimEdges = function (box) {
    var drop = function (node) {
      return node && ((node.nodeType === 3 && blankText(node)) || (node.nodeType === 1 && node.tagName === 'BR') || node.nodeType === 8);
    };
    while (drop(box.firstChild)) box.removeChild(box.firstChild);
    while (drop(box.lastChild)) box.removeChild(box.lastChild);
  };
  var embedRatio = function (frame, holder) {
    /* "padding-bottom: 56.25%" ya da "padding: 177.78% 0 0 0" ile verilmiş oran */
    var pads = holder && holder !== frame ? [holder.style.paddingBottom, holder.style.paddingTop] : [];
    for (var i = 0; i < pads.length; i += 1) {
      if (pads[i] && pads[i].indexOf('%') > -1 && parseFloat(pads[i]) > 0) return 100 / parseFloat(pads[i]);
    }
    var w = frame.getAttribute('width');
    var h = frame.getAttribute('height');
    if (w && h && !/%/.test(w + h) && parseFloat(w) > 0 && parseFloat(h) > 0) return parseFloat(w) / parseFloat(h);
    return 16 / 9;
  };
  var makeEmbed = function (frame, ratio, title) {
    var wrap = document.createElement('div');
    ratio = Math.min(2.4, Math.max(0.5, ratio));
    wrap.className = 'rs-embed' + (ratio < 1 ? ' is-tall' : '');
    wrap.style.aspectRatio = String(Math.round(ratio * 1000) / 1000);
    frame.removeAttribute('style');
    frame.removeAttribute('width');
    frame.removeAttribute('height');
    frame.setAttribute('loading', 'lazy');
    if (!frame.getAttribute('title') && title) frame.setAttribute('title', title);
    wrap.appendChild(frame);
    return wrap;
  };
  /* YouTube oynatıcısı sayfa açılışında yüklenmez (yaklaşık 2 MB kod ve reklam istekleri):
     yerine kapak görselli bir düğme konur, oynatıcı dokununca gelir. */
  var youtubeId = function (text) {
    var hit = String(text || '').match(/(?:youtube(?:-nocookie)?\.com\/embed\/|^)([\w-]{6,})(?:[?&#]|$)/);
    return hit ? hit[1] : '';
  };
  var makeFacade = function (id, ratio, title, label) {
    var wrap = document.createElement('div');
    ratio = Math.min(2.4, Math.max(0.5, ratio));
    wrap.className = 'rs-embed' + (ratio < 1 ? ' is-tall' : '');
    wrap.style.aspectRatio = String(Math.round(ratio * 1000) / 1000);
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'rs-embed__play';
    button.setAttribute('aria-label', label);
    var poster = document.createElement('img');
    poster.alt = '';
    poster.loading = 'lazy';
    poster.decoding = 'async';
    /* Seçilen kapak videoda yoksa YouTube 120px'lik gri yer tutucu ya da 404 döndürür, o zaman
       480px'lik kapağa inilir */
    var hq = 'https://i.ytimg.com/vi/' + id + '/hqdefault.jpg';
    poster.addEventListener('load', function () { if (poster.naturalWidth <= 120 && poster.src !== hq) poster.src = hq; });
    poster.addEventListener('error', function () { if (poster.src !== hq) poster.src = hq; });
    /* Kapak boyutu kutuya göre: sddefault 640×480'dir ve 16:9 videoda yalnız 640×360 gerçek görüntü
       taşır. Kutunun aygıt pikseli genişliği (dikey videoda kırpılan yükseklik) 960'ı aşıyorsa
       1280px'lik maxres, aşmıyorsa 640px'lik kapak (maxres'e göre ~100 KB daha az) iner. */
    var dpr = window.devicePixelRatio || 1;
    var boxW = Math.min(560, (document.documentElement.clientWidth || 390) - 40);
    var need = ratio < 1 ? boxW * dpr / ratio * (9 / 16) : boxW * dpr;
    var posterSrc = 'https://i.ytimg.com/vi/' + id + (need > 960 ? '/maxresdefault.jpg' : '/sddefault.jpg');
    /* Kapak ekrana yaklaşınca iner: tarayıcının tembel yüklemesi 1–2 ekran önceden başlıyor ve
       açıklamanın dibindeki video, ürün kapağıyla aynı anda inip mobilde ilk görüntüyü geciktiriyordu */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) {
        if (en[0].isIntersecting) { poster.src = posterSrc; io.disconnect(); }
      }, { rootMargin: '300px 0px' });
      io.observe(button);
    } else {
      poster.src = posterSrc;
    }
    button.appendChild(poster);
    button.addEventListener('click', function () {
      var frame = document.createElement('iframe');
      frame.setAttribute('allowfullscreen', '');
      frame.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
      if (title) frame.setAttribute('title', title);
      frame.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
      wrap.replaceChild(frame, button);
      frame.focus();
    });
    wrap.appendChild(button);
    return wrap;
  };
  /* Vimeo videoları alan adına göre kısıtlanabiliyor: izin yoksa oynatıcı yerine İngilizce bir
     "Sorry – because of its privacy settings…" kutusu çıkar. Vimeo'nun oEmbed yanıtı, isteği yapan
     sayfanın alan adına izin yoksa domain_status_code 403 verir (video silinmişse ya da gizliyse
     istek 403/404 döner): o durumda kutu hiç gösterilmez. İzin varsa videonun gerçek oranı kutuya
     uygulanır (dikey videolar 16:9 kutuda kalmasın). Yanıt alınamazsa hiçbir şeye dokunulmaz. */
  var checkVimeo = function (wrap, frame) {
    var hit = String(frame.getAttribute('data-rs-vimeo') || frame.getAttribute('src') || '').match(/player\.vimeo\.com\/video\/(\d+)/);
    if (!hit || !window.fetch) return;
    fetch('https://vimeo.com/api/oembed.json?url=' + encodeURIComponent('https://vimeo.com/' + hit[1]))
      .then(function (response) {
        if (response.status === 403 || response.status === 404) return { domain_status_code: 403 };
        return response.ok ? response.json() : {};
      })
      .then(function (data) {
        if (data.domain_status_code === 403) {
          var media = wrap.parentNode;
          if (!media) return;
          media.removeChild(wrap);
          if (!media.children.length && media.parentNode) media.parentNode.removeChild(media);
          return;
        }
        var ratio = data.width > 0 && data.height > 0 ? data.width / data.height : 0;
        if (!ratio) return;
        ratio = Math.min(2.4, Math.max(0.5, ratio));
        wrap.style.aspectRatio = String(Math.round(ratio * 1000) / 1000);
        wrap.classList.toggle('is-tall', ratio < 1);
      })
      .catch(function () {});
  };
  var hostLabel = function (a) {
    var host = (a.hostname || '').replace(/^www\./, '');
    if (/instagram\.com$/.test(host)) return 'Instagram';
    if (/youtube\.com$|youtu\.be$/.test(host)) return 'YouTube';
    if (/apps\.apple\.com$/.test(host)) return 'App Store';
    if (/play\.google\.com$/.test(host)) return 'Google Play';
    return '';
  };

  var tidyDescription = function (box, after) {
    var section = box.parentNode;
    var title = box.getAttribute('data-rs-embed-title') || '';
    var playLabel = box.getAttribute('data-rs-play-label') || 'Videoyu oynat';
    var embeds = [];
    var facades = 0;
    var facade = function (id, ratio) {
      facades += 1;
      var label = (title ? title + ': ' : '') + playLabel + (facades > 1 ? ' (' + facades + ')' : '');
      return makeFacade(id, ratio, title, label);
    };

    /* 1) Gömülü videolar: kendi sarmalayıcılarından çıkar, oranı korunarak ızgaraya girer */
    Array.prototype.forEach.call(box.querySelectorAll('iframe'), function (frame) {
      var holder = frame.parentNode !== box && frame.parentNode.children.length === 1 ? frame.parentNode : frame;
      /* Bölüm, YouTube adresini data-rs-yt'ye taşır (çerçeve hiç yüklenmesin diye); eski biçim de tanınır */
      var yt = youtubeId(frame.getAttribute('data-rs-yt') || frame.getAttribute('src'));
      if (yt) {
        embeds.push(facade(yt, embedRatio(frame, holder)));
        frame.parentNode.removeChild(frame);
      } else {
        var embed = makeEmbed(frame, embedRatio(frame, holder), title);
        embeds.push(embed);
        checkVimeo(embed, frame);
        /* Adressiz basılan Vimeo çerçevesi görünür alana yaklaşınca yüklenir */
        var lazySrc = frame.getAttribute('data-rs-vimeo');
        if (lazySrc) {
          var load = function () { if (!frame.getAttribute('src')) frame.setAttribute('src', lazySrc); };
          if ('IntersectionObserver' in window) {
            var io = new IntersectionObserver(function (entries) {
              if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); load(); }
            }, { rootMargin: '300px 0px' });
            io.observe(embed);
          } else load();
        }
      }
      /* boş kalan sarmalayıcı (ve onu saran boş paragraf) kaldırılır */
      while (holder !== frame && holder !== box && holder.parentNode && !holder.children.length && !/\S/.test(holder.textContent)) {
        var up = holder.parentNode;
        up.removeChild(holder);
        holder = up;
      }
    });

    /* 2) Metin olarak bırakılmış çıplak adresler: YouTube ise gömülür, değilse bağlantı olur */
    var walker = document.createTreeWalker(box, NodeFilter.SHOW_TEXT, null);
    var bare = [];
    while (walker.nextNode()) {
      var text = walker.currentNode;
      if (/^\s*https?:\/\/\S+\s*$/.test(text.nodeValue) && !text.parentNode.closest('a')) bare.push(text);
    }
    bare.forEach(function (text) {
      var url = text.nodeValue.trim();
      var yt = url.match(/(?:youtube\.com\/(shorts\/|watch\?v=|embed\/)|youtu\.be\/)([\w-]{6,})/);
      if (yt) {
        embeds.push(facade(yt[2], yt[1] === 'shorts/' ? 9 / 16 : 16 / 9));
        text.parentNode.removeChild(text);
      } else {
        var link = document.createElement('a');
        link.href = url;
        link.textContent = url.replace(/^https?:\/\/(www\.)?/, '').replace(/\/$/, '');
        text.parentNode.replaceChild(link, text);
      }
    });

    /* 3) Sondaki bağlantı dizisi: tek satır aralıkla alt alta yazılmış en az iki bağlantı */
    var scope = box;
    trimEdges(box);
    var last = box.lastChild;
    if (last && last.nodeType === 1 && /^(P|DIV)$/.test(last.tagName)) {
      var onlyLinks = Array.prototype.every.call(last.childNodes, function (node) {
        if (node.nodeType === 3) return blankText(node);
        if (node.nodeType === 8) return true;
        return node.nodeType === 1 && (node.tagName === 'BR' || (node.tagName === 'A' && node.getAttribute('href')));
      });
      if (onlyLinks) scope = last;
    }
    var run = [];
    var links = [];
    var breaks = 0;
    var node = scope.lastChild;
    while (node) {
      if (node.nodeType === 3) {
        if (!blankText(node)) break;
      } else if (node.nodeType === 1 && node.tagName === 'BR') {
        breaks += 1;
        if (breaks > 1 && links.length) break; /* boş satır: dizi burada biter */
      } else if (node.nodeType === 1 && node.tagName === 'A' && node.getAttribute('href')) {
        links.unshift(node);
        breaks = 0;
      } else if (node.nodeType !== 8) {
        break;
      }
      run.push(node);
      node = node.previousSibling;
    }
    var list = null;
    if (links.length >= 2) {
      list = document.createElement('ul');
      list.className = 'rs-desc__links';
      var label = box.getAttribute('data-rs-links-label');
      if (label) list.setAttribute('aria-label', label);
      links.forEach(function (a) {
        /* Eski siteden kalan kalıp bağlantılar çipe dönüşmez: mağazanın kendi ana sayfası
           (ziyaretçi zaten mağazada) ve satıştan kalkan uygulamanın mağaza sayfaları */
        var host = (a.hostname || '').replace(/^www\./, '');
        var oldShop = /(^|\.)oyunperest\.com\.tr$/.test(host) && /^\/(magaza\/?)?$/.test(a.pathname || '/');
        if (oldShop || host === 'apps.apple.com' || host === 'play.google.com') return;
        var name = a.textContent.replace(/\s+/g, ' ').trim() || hostLabel(a);
        if (!name) return; /* yazısı olmayan, tanınmayan bağlantı çipe dönüşmez */
        a.textContent = name;
        if (a.hostname && a.hostname !== window.location.hostname) {
          a.setAttribute('target', '_blank');
          a.setAttribute('rel', 'noopener');
        }
        var item = document.createElement('li');
        item.appendChild(a);
        list.appendChild(item);
      });
      /* çipe taşınan bağlantılar artık listededir; geride kalan satır sonları ve boşluklar silinir */
      run.forEach(function (n) { if (n.parentNode === scope) scope.removeChild(n); });
      if (scope !== box && !scope.childNodes.length) box.removeChild(scope);
      trimEdges(box);
      if (!list.children.length) list = null;
    }

    if (embeds.length) {
      var media = document.createElement('div');
      media.className = 'rs-desc__media';
      embeds.forEach(function (embed) { media.appendChild(embed); });
      section.insertBefore(media, after.nextSibling);
    }
    if (list) section.appendChild(list);
    trimEdges(box);
    /* Açıklama yalnız video ve bağlantıdan ibaretse boş kutu yer tutmasın */
    if (!/\S/.test(box.textContent.replace(/\u00a0/g, ' ')) && !box.querySelector('img, video')) box.hidden = true;
  };

  /* ---- Uzun açıklama: sığmıyorsa "devamını oku" çıkar ---- */
  document.querySelectorAll('[data-rs-clamp]').forEach(function (box) {
    var toggle = box.parentNode.querySelector('[data-rs-clamp-toggle]');
    if (!toggle) return;
    try {
      tidyDescription(box, toggle);
    } catch (error) {
      /* düzenleme başarısız olursa açıklama olduğu gibi kalır; bekletilen YouTube çerçeveleri adresine kavuşur */
      Array.prototype.forEach.call(box.querySelectorAll('iframe[data-rs-yt]'), function (frame) {
        frame.src = 'https://www.youtube-nocookie.com/embed/' + frame.getAttribute('data-rs-yt');
      });
    }
    if (!box.hidden && box.scrollHeight > box.clientHeight + 8) {
      /* Kesim bir ara başlığın üstüne denk gelirse (alt kenarda yarı solgun başlık) başlığın önünde biter */
      var cut = box.clientHeight;
      var line = parseFloat(getComputedStyle(box).lineHeight) || 27;
      Array.prototype.some.call(box.querySelectorAll('h3, h4, strong, b'), function (head) {
        /* yalnız satır başındaki kalın yazı ara başlıktır; cümle içindeki vurgu değil */
        var prev = head.previousSibling;
        while (prev && prev.nodeType === 3 && blankText(prev)) prev = prev.previousSibling;
        if (!/^H[34]$/.test(head.tagName) && prev && prev.nodeName !== 'BR') return false;
        var top = head.offsetTop;
        if (head.offsetParent !== box || top < line * 4) return false;
        if (top > cut - line * 3 && top < cut) { box.style.maxHeight = top + 'px'; return true; }
        return false;
      });
      toggle.hidden = false;
      toggle.addEventListener('click', function () {
        box.classList.add('is-open');
        box.style.maxHeight = '';
        toggle.setAttribute('aria-expanded', 'true');
        toggle.hidden = true;
        /* düğme kaybolunca odak boşa düşmesin: okuma metnin başından sürer */
        box.setAttribute('tabindex', '-1');
        box.focus({ preventScroll: true });
      });
    } else {
      box.classList.add('is-open');
    }
  });

  /* ---- Geniş ekranda yatay şeritlere ok düğmeleri (fareyle kaydırma yok) ----
     Şerit sonradan dolarsa (ürün yorumları) aynı işlev yeniden çağrılır. */
  var wide = window.matchMedia('(min-width: 990px)').matches;
  var addArrows = function (sc) {
    if (!wide || sc.hasAttribute('data-rs-arrows')) return;
    var section = sc.closest('.rs-section') || sc.parentNode;
    var head = section.querySelector('.rs-head, .rs-proofhead');
    if (!head || sc.scrollWidth <= sc.clientWidth + 8) return;
    sc.setAttribute('data-rs-arrows', '');
    var make = function (label, text) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'rs-arrow'; b.textContent = text; b.setAttribute('aria-label', label);
      return b;
    };
    var back = make('Geri', '←');
    var fwd = make('İleri', '→');
    var box = document.createElement('div');
    box.className = 'rs-railnav';
    box.appendChild(back); box.appendChild(fwd);
    head.appendChild(box);
    var sync = function () {
      back.disabled = sc.scrollLeft < 8;
      fwd.disabled = sc.scrollLeft + sc.clientWidth > sc.scrollWidth - 8;
    };
    back.addEventListener('click', function () { sc.scrollBy({ left: -sc.clientWidth * 0.8, behavior: glide }); });
    fwd.addEventListener('click', function () { sc.scrollBy({ left: sc.clientWidth * 0.8, behavior: glide }); });
    sc.addEventListener('scroll', sync, { passive: true });
    sync();
  };

  /* ---- Yorum kartı: sekiz satıra sığmayan yorum kesik kalmasın, "devamını oku" eklenir ----
     Ürün sayfasındaki ve ana sayfadaki yorum şeritleri aynı işlevi kullanır. */
  var addReadMore = function (holder, label) {
    if (!holder || !label) return;
    Array.prototype.forEach.call(holder.querySelectorAll('.rs-rev > p'), function (text) {
      if (text.parentNode.querySelector('.rs-rev__more') || text.scrollHeight <= text.clientHeight + 2) return;
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'rs-rev__more';
      button.textContent = label;
      button.addEventListener('click', function () {
        text.parentNode.classList.add('is-open');
        button.parentNode.removeChild(button);
        text.setAttribute('tabindex', '-1');
        text.focus({ preventScroll: true });
      });
      text.parentNode.insertBefore(button, text.nextSibling);
    });
  };
  /* Ölçüm yazı tipi yerleştikten sonra yapılır (satır sayısı yazı tipine bağlı) */
  var whenSettled = function (fn) {
    if (document.fonts && document.fonts.ready && document.fonts.ready.then) document.fonts.ready.then(fn, fn);
    else window.addEventListener('load', fn);
  };

  /* ---- Ürün yorumları: gerçek pazaryeri yorumları, kaynağıyla ----
     Yorumlar başka satıcılardan (Amazon, Kitapyurdu) derlendi. O satıcının kargosunu,
     paketini ya da teslimatını anlatan yorum bu mağaza için bir şey söylemez; gösterilmez.
     Kalanlar puana göre dizilir (aynı puanda dosyadaki sıra korunur). */
  var offTopic = /kargo|koli|ambalaj|paketle|teslim|satıcı|amazon|yırtı|ıslak|ezil|ezik|hasarl|iade/;
  var pickReviews = function (list) {
    var seen = {};
    return list
      .map(function (r, index) { return { r: r, index: index }; })
      .filter(function (item) {
        var text = String(item.r.t || '').replace(/\s+/g, ' ').trim();
        if (!text || seen[text] || offTopic.test(text.toLocaleLowerCase('tr'))) return false;
        seen[text] = true;
        return true;
      })
      .sort(function (a, b) { return (Number(b.r.r) || 0) - (Number(a.r.r) || 0) || a.index - b.index; })
      .map(function (item) { return item.r; });
  };
  var reviews = document.querySelector('[data-rs-reviews]');
  /* Yorum bölümü açılmadıysa satın alma kartındaki puan satırı boş bir çapaya gitmesin */
  var noReviews = function () {
    var rate = document.querySelector('[data-rs-rate-link]');
    if (rate) rate.removeAttribute('href');
  };
  if (reviews && window.fetch) {
    var esc = function (t) {
      return String(t).replace(/[&<>"]/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
      });
    };
    fetch(reviews.getAttribute('data-rs-reviews'))
      .then(function (response) { return response.ok ? response.json() : {}; })
      .then(function (all) {
        var list = pickReviews(all[reviews.getAttribute('data-rs-handle')] || []);
        if (!list.length) { noReviews(); return; }
        var holder = reviews.querySelector('[data-rs-reviews-list]');
        holder.innerHTML = list.map(function (r) {
          var stars = Math.max(0, Math.min(5, Number(r.r) || 0));
          return '<article class="rs-rev"><div class="rs-rev__st" role="img" aria-label="5 üzerinden ' + stars + '">' + '★★★★★'.slice(0, stars) + '</div>' +
            '<p>' + esc(r.t) + '</p><footer><b>' + esc(r.a) + '</b>' + esc(r.s) + '</footer></article>';
        }).join('');
        reviews.hidden = false;

        var more = reviews.getAttribute('data-rs-more-label');
        addReadMore(holder, more);
        whenSettled(function () { addReadMore(holder, more); });
        addArrows(holder);
      })
      .catch(noReviews);
  } else {
    noReviews();
  }

  /* ---- Tarayıcı çubuğu rengi: başlık ekrandayken sahne rengi, aşağıda kâğıt ----
     <head>'deki theme-color kâğıt rengiyle gelir (snippets/meta-tags.liquid): sahne rengini
     gövdedeki bölümler belirlediği için <head> onu bilemez. Başlık sahneyle aynı renkte
     olduğundan, başlık ekrandayken çubuk sahne rengine döner; başlık kaydırılıp gidince
     kâğıda geri döner. JS yoksa çubuk kâğıt renginde kalır. */
  var themeMeta = document.querySelector('meta[name="theme-color"]');
  var themePaper = themeMeta ? themeMeta.getAttribute('content') : '';
  var themeAtTop = true;
  var syncThemeColor = function () {
    if (!themeMeta) return;
    var stage = getComputedStyle(document.documentElement).getPropertyValue('--rs-stage').trim();
    themeMeta.setAttribute('content', themeAtTop && stage ? stage : themePaper);
  };
  var themeHeader = document.querySelector('.rs-header');
  if (themeMeta && themeHeader && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      themeAtTop = entries[entries.length - 1].isIntersecting;
      syncThemeColor();
    }).observe(themeHeader);
  }
  syncThemeColor();

  /* ---- Ana sayfa sahnesi: öne gelen kitap sayfayı kendi rengine boyar ---- */
  var feat = document.querySelector('[data-rs-feat]');
  if (feat && feat.children.length) {
    var root = document.documentElement;
    var title = document.querySelector('[data-rs-cap-title]');
    var meta = document.querySelector('[data-rs-cap-meta]');
    var link = document.querySelector('[data-rs-cap-link]');
    var dots = document.querySelector('[data-rs-dots]');
    var items = Array.prototype.slice.call(feat.children);
    var current = -1;
    if (dots) dots.innerHTML = items.map(function () { return '<i></i>'; }).join('');

    var show = function (index) {
      if (index === current) return;
      current = index;
      var item = items[index];
      root.style.setProperty('--rs-stage', item.getAttribute('data-stage'));
      root.style.setProperty('--rs-on', item.getAttribute('data-on'));
      syncThemeColor();
      if (title) title.textContent = item.getAttribute('data-title');
      if (meta) meta.textContent = item.getAttribute('data-meta');
      if (link) link.href = item.href;
      items.forEach(function (a, n) { a.classList.toggle('is-on', n === index); });
      if (dots) Array.prototype.forEach.call(dots.children, function (d, n) { d.classList.toggle('is-on', n === index); });
    };

    var queued = false;
    feat.addEventListener('scroll', function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        var mid = feat.scrollLeft + feat.clientWidth / 2;
        var best = 0;
        var distance = Infinity;
        items.forEach(function (a, n) {
          var d = Math.abs(a.offsetLeft + a.offsetWidth / 2 - mid);
          if (d < distance) { distance = d; best = n; }
        });
        show(best);
      });
    }, { passive: true });

    /* Öndeki kapak bağlantıdır; yandaki kapağa dokunmak onu öne getirir */
    feat.addEventListener('click', function (event) {
      var a = event.target instanceof Element ? event.target.closest('a') : null;
      if (!a || a.classList.contains('is-on')) return;
      event.preventDefault();
      feat.scrollTo({ left: a.offsetLeft - (feat.clientWidth - a.offsetWidth) / 2, behavior: glide });
    });
    show(0);

    var go = function (index) {
      var n = (index + items.length) % items.length;
      var a = items[n];
      feat.scrollTo({ left: a.offsetLeft - (feat.clientWidth - a.offsetWidth) / 2, behavior: glide });
    };
    var prev = document.querySelector('[data-rs-feat-prev]');
    var next = document.querySelector('[data-rs-feat-next]');

    /* Masaüstünde sahne kendiliğinden ilerler: renk değişimi keşfedilmeyi beklemesin.
       Ziyaretçi sahneye dokunduğu anda kalıcı olarak durur; üzerine gelince bekler. */
    var timer = null;
    var hovering = false;
    var stop = function () { if (timer) { clearInterval(timer); timer = null; } };
    var desktop = window.matchMedia('(min-width: 990px) and (hover: hover)').matches;
    if (feat.hasAttribute('data-rs-autoplay') && desktop && !calm && items.length > 1) {
      timer = setInterval(function () { if (!hovering && !document.hidden) go(current + 1); }, 5200);
      var hero = feat.closest('.rs-hero') || feat;
      hero.addEventListener('mouseenter', function () { hovering = true; });
      hero.addEventListener('mouseleave', function () { hovering = false; });
      ['pointerdown', 'wheel', 'keydown', 'touchstart'].forEach(function (type) {
        hero.addEventListener(type, stop, { passive: true });
      });
    }
    if (prev) prev.addEventListener('click', function () { stop(); go(current - 1); });
    if (next) next.addEventListener('click', function () { stop(); go(current + 1); });
  }

  /* ---- Sayfadaki hazır şeritlere ok düğmeleri ---- */
  document.querySelectorAll('.rs-hscroll').forEach(addArrows);

  /* ---- Ana sayfadaki yorum kartları: uzun yoruma "devamını oku" ---- */
  whenSettled(function () {
    document.querySelectorAll('.rs-hscroll[data-rs-more-label]').forEach(function (row) {
      addReadMore(row, row.getAttribute('data-rs-more-label'));
    });
  });

  /* ---- Seçili çip görünür olsun: yatay şerit seçili çipe kaydırılır ----
     Sayfa yeniden yüklenince şerit başa döner; sondaki seçili konu ya da yaş ekran dışında kalırdı.
     Yalnız şeridin kendi yatay konumu değişir, sayfa kaymaz. */
  document.querySelectorAll('.rs-coll__nav [aria-current], .rs-bar__chips .rs-chip.is-on').forEach(function (chip) {
    var strip = chip.parentNode;
    if (!strip || strip.scrollWidth <= strip.clientWidth + 1) return;
    var box = strip.getBoundingClientRect();
    var at = chip.getBoundingClientRect();
    if (at.left >= box.left && at.right <= box.right) return;
    strip.scrollLeft += at.left - box.left - (strip.clientWidth - at.width) / 2;
  });

  /* ---- "Daha fazla yükle" sonrası odak: klavye, yeni gelen ilk kitaptan devam eder ----
     Yükleme oyunperest.js'tedir ve basılan bağlantıyı yenisiyle değiştirir; odak boşa düşmesin. */
  var grid = document.querySelector('[data-op-grid]');
  if (grid && window.MutationObserver) {
    var loading = false;
    document.addEventListener('click', function (event) {
      if (event.target instanceof Element && event.target.closest('[data-op-load-more]')) loading = true;
    }, true);
    new MutationObserver(function (records) {
      if (!loading) return;
      var first = null;
      records.forEach(function (record) {
        Array.prototype.forEach.call(record.addedNodes, function (node) {
          if (!first && node.nodeType === 1 && node.classList.contains('rs-card')) first = node;
        });
      });
      if (!first) return;
      loading = false;
      var active = document.activeElement;
      if (active && active !== document.body && document.contains(active)) return;
      var target = first.querySelector('h3 a');
      if (target) target.focus({ preventScroll: true });
    }).observe(grid, { childList: true });
  }

  /* ---- Sepete eklendi: kalıcı işaret + sepete giden bildirim ----
     Ekleme isteği oyunperest.js'tedir ([data-op-add]); düğme 1,6 sn sonra eski haline döner
     ve ekranda başka bir şey değişmez. Burada yalnız sonuç görünür kılınır: basılan düğme
     işaretli kalır (yeniden basılabilir), altta sepete götüren kısa bir bildirim çıkar,
     koleksiyon sayfasındaki sepet çipi açılır. Ekran okuyucu duyurusunu oyunperest.js yapar;
     bildirim bu yüzden canlı bölge değildir. Başarı "op:cart-updated" olayından anlaşılır;
     aynı olay sepet sayfasındaki adet değişiminde de geldiği için yalnız az önce basılmış
     bir ekleme düğmesi varken dikkate alınır.
     Ekleme başarısız olursa oyunperest.js "op:cart-error" olayını yayar; neden (Shopify'ın
     kendi cümlesi ya da genel cümle) aynı bildirimde, .rs-toast--error sınıfıyla gösterilir. */
  var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var onCartPage = /\/cart\/?$/.test(window.location.pathname);
  var toast = null;
  var toastTimer = null;
  var showToast = function (message, linkLabel, failed) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'rs-toast';
      toast.appendChild(document.createElement('div')).className = 'rs-toast__in';
      document.body.appendChild(toast);
    }
    var inner = toast.firstChild;
    inner.textContent = '';
    inner.appendChild(document.createElement('span')).textContent = message;
    if (linkLabel) {
      var link = document.createElement('a');
      link.href = cartRoot + 'cart';
      link.textContent = linkLabel;
      inner.appendChild(link);
    }
    toast.classList.toggle('rs-toast--plain', !linkLabel);
    toast.classList.toggle('rs-toast--error', !!failed);
    void toast.offsetWidth; /* ilk gösterimde geçiş çalışsın */
    toast.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function hide() {
      /* bağlantıya gelinmişse (fare ya da klavye) bildirim altından çekilmez */
      if (toast.matches(':hover') || toast.contains(document.activeElement)) { toastTimer = setTimeout(hide, 1500); return; }
      toast.classList.remove('is-on');
    }, failed ? 7000 : 5000); /* hata cümlesi daha uzundur; okunacak kadar kalır */
  };

  var pending = null;
  document.addEventListener('click', function (event) {
    var button = event.target instanceof Element ? event.target.closest('[data-op-add]') : null;
    if (!button || button.disabled) return;
    button.classList.remove('is-added');
    pending = { button: button, at: Date.now() };
  }, true);
  /* Yuvarlak "+" düğmesinde hata yalnız "!" olarak, geniş düğmede "Tekrar deneyin" olarak
     görünür: nedenini bildirim söyler. Bölüm hatayı kendi yerinde gösteriyorsa (sepet) olayı
     preventDefault ile üstlenir; o karar bütün dinleyiciler çalıştıktan sonra okunur. */
  document.addEventListener('op:cart-error', function (event) {
    var detail = event.detail || {};
    if (pending && (!detail.button || pending.button === detail.button)) pending = null;
    setTimeout(function () {
      if (event.defaultPrevented) return;
      showToast(detail.message || 'Sepete eklenemedi. Lütfen tekrar deneyin.', '', true);
    }, 0);
  });
  document.addEventListener('op:cart-updated', function () {
    var entry = pending;
    if (!entry || Date.now() - entry.at > 20000) return;
    pending = null;
    entry.button.classList.add('is-added');
    document.querySelectorAll('[data-rs-cart-pill]').forEach(function (pill) { pill.hidden = false; });
    if (!onCartPage) showToast('Sepete eklendi', 'Sepete git');
  });
})();
